import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AppRoutes from "./routes";
import axiosInstance from "./api/axiosInstance";
import Header from "./components/Header";
import FooterNigranLegal from "./components/FooterNigranLegal";
import FloatingHelp from "./components/FloatingHelp";
import CookieBanner from "./components/CookieBanner";
import { useTranslation } from "react-i18next";
import './App.css';
import './styles/Header.css';

const TEMPORARY_MAINTENANCE_MODE = true;

function MaintenanceScreen() {
  return (
    <main className="maintenance-screen" aria-labelledby="maintenance-title">
      <div className="maintenance-logo-wrap">
      </div>
      <h1 id="maintenance-title">
        A INSCRIPCIÓN VIA WEB FINALIZOU
      </h1>
    </main>
  );
}

function App() {
  const [maintenance, setMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { t } = useTranslation();

  const allowedWhileMaintenance = [
    "/admin",
    "/admin/",
    "/login",
    "/registrarse"
  ];

  const isAllowed = allowedWhileMaintenance.some(route =>
    location.pathname.startsWith(route)
  );

  const loginOrRegisterRoutes = ["/login", "/registrarse"];
  const isLoginOrRegister = loginOrRegisterRoutes.includes(location.pathname);

  useEffect(() => {
    if (TEMPORARY_MAINTENANCE_MODE) {
      setLoading(false);
      return;
    }

    const token = localStorage.getItem("token");

    if (!token) {
      setLoading(false);
      return;
    }

    axiosInstance.get("/admin/config/")
      .then(res => setMaintenance(res.data.maintenance_mode))
      .catch(() => {
        setMaintenance(false);
      })
      .finally(() => setLoading(false));
  }, []);

  if (TEMPORARY_MAINTENANCE_MODE) {
    return (
      <MaintenanceScreen />
    );
  }

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        {t("loading")}
      </div>
    );
  }

  if (maintenance && !isAllowed) {
    return (
      <MaintenanceScreen />
    );
  }

  return (
    <div className="layout-root">
      <Header />
      <div className={`main-content${isLoginOrRegister ? " login-bg" : ""}`}>
        <AppRoutes />
      </div>
      <FloatingHelp />
      <FooterNigranLegal />
      <CookieBanner />
    </div>
  );
}

export default App;
